import React from 'react';

import Tooltip from '@atlaskit/tooltip/Tooltip';

export const ConditionalTooltip = ({
	withTooltip,
	content,
	children,
}: {
	withTooltip: boolean;
	content: string;
	children: React.ReactNode;
}):
	| string
	| number
	| boolean
	| Iterable<React.ReactNode>
	| React.JSX.Element
	| null
	| undefined => {
	return withTooltip ? <Tooltip content={content}>{children}</Tooltip> : children;
};
